import type { Vector } from './vector.ts';

import type { WeaponName } from './weapons.ts';

export type EntityId = string;

/** A CSS colour. The colour *is* the team; there is no other identity. */
export type Team = string;

export interface PlayerInput {
  up: boolean;
  down: boolean;
  left: boolean;
  right: boolean;
  shoot: boolean;
  /** Where the player points, relative to their own position. */
  aim: { x: number; y: number };
}

interface EntityBase {
  id: EntityId;
  position: Vector;
  /** Radius: every entity in this game is a circle. */
  size: number;
}

export interface Player extends EntityBase {
  kind: 'player';
  name: string;
  team: Team;
  aim: Vector;
  weapon: WeaponName;
  clip: number;
  /** Milliseconds left before the weapon can fire again. */
  cooldown: number;
  /** Milliseconds left of the reload in progress; 0 when not reloading. */
  reload: number;
  /** Milliseconds left of the shove; 0 when not dashing. */
  dash: number;
  /** Milliseconds before another dash is allowed. */
  dashCooldown: number;
  /** Server-side only: what the client last said its keys and mouse were. */
  input: PlayerInput;
}

export interface Bullet extends EntityBase {
  kind: 'bullet';
  team: Team;
  ownerId: EntityId;
  /** Pixels per second, direction included. */
  velocity: Vector;
  /** Pixels left before it dies of old age. */
  range: number;
}

export interface ControlPoint extends EntityBase {
  kind: 'control-point';
  ownerTeam: Team | null;
  capturingTeam: Team | null;
  /** Hits landed towards the capture, up to `CAPTURE_THRESHOLD`. */
  capture: number;
}

export type Entity = Player | Bullet | ControlPoint;

export function emptyInput(): PlayerInput {
  return {
    up: false,
    down: false,
    left: false,
    right: false,
    shoot: false,
    aim: { x: 1, y: 0 },
  };
}
